import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let imageBox = class imageBox extends Vue {
    item;
    borderColor = colors.borderItemHover;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    isBlur = localStorage.getItem('privacyMode') === 'true';
    // get gross() {
    //   return this.item.incidentType !== 'FACE_MATCH' && this.item.incidentType !== 'FACE_PEDESTRIAN';
    // }
    get faceMatch() {
        return (this.item.incidentType === 'FACE_MATCH' ||
            this.item.incidentType === 'FACE_PEDESTRIAN' ||
            this.item.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED' ||
            this.item.incidentType === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED' ||
            this.item.incidentType === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED' ||
            ((this.item.incidentType === 'INCIDENT_EVERYTHING_MATCHED' || this.item.incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
                this.item.everythingAnnotation?.everythingAlertType === 'image'));
    }
    // get facePedestrian() {
    //   return this.item.incidentType === 'FACE_PEDESTRIAN';
    // }
    // getPanoramicImage(val: any) {
    //   return val.incidentType === 'INCIDENT_FACE_UNMATCHED' ? val.faceAnnotation.portraitCaptureImage : val.panoramicImage;
    // }
    get getPanoramicImage() {
        let value = '';
        if (this.item.pedestrianAnnotation) {
            value = this.item.pedestrianAnnotation?.portraitCaptureImage;
        }
        else if (this.item.faceAnnotation) {
            value = this.item.faceAnnotation?.portraitCaptureImage;
        }
        else if (this.item.automobileAnnotation) {
            value = this.item?.automobileAnnotation?.portraitCaptureImage;
        }
        else {
            value = this.item.panoramicImage;
        }
        return value;
    }
    getThreshold() {
        // return (val * 100).toFixed(2) + '%';
        let value = '';
        if (this.item.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            value = (this.item.pedestrianAnnotation.value * 100).toFixed(2) + '%';
        }
        else if (this.item.incidentType === 'FACE_MATCH') {
            value = (this.item.faceAnnotation.value * 100).toFixed(2) + '%';
        }
        else if ((this.item.incidentType === 'INCIDENT_EVERYTHING_MATCHED' || this.item.incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
            this.item.everythingAnnotation?.everythingAlertType === 'image') {
            value = (this.item.everythingAnnotation?.value * 100).toFixed(2) + '%';
        }
        return value;
    }
    getPortraitCaptureImage() {
        // return val.portraitCaptureImage;
        let value = '';
        if (this.item.pedestrianAnnotation) {
            value = this.item.pedestrianAnnotation?.portraitCaptureImage;
        }
        else if (this.item.faceAnnotation) {
            value = this.item.faceAnnotation?.portraitCaptureImage;
        }
        else if (this.item.automobileAnnotation) {
            value = this.item?.automobileAnnotation?.portraitCaptureImage;
        }
        else if (this.item?.everythingAnnotation) {
            value = this.item?.everythingAnnotation?.captureSmallImage;
        }
        else {
            value = this.item.panoramicImage;
        }
        return value;
    }
    getPortraitImage() {
        // return val.portraitImage;
        let value = '';
        if (this.item.pedestrianAnnotation) {
            value = this.item.pedestrianAnnotation?.portraitImage;
        }
        else if (this.item.faceAnnotation) {
            value = this.item.faceAnnotation?.portraitImage;
        }
        else if (this.item.automobileAnnotation) {
            value = this.item?.automobileAnnotation?.vehicleImage;
        }
        else if (this.item?.everythingAnnotation) {
            value = this.item?.everythingAnnotation?.originImage;
        }
        return value;
    }
    get setPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
};
__decorate([
    Prop()
], imageBox.prototype, "item", void 0);
imageBox = __decorate([
    Component({
        name: 'imageBox',
        components: {
            BlurPicture,
        },
        i18n: {
            messages: {
                'en-us': {
                    systemList: 'Alert Notification',
                    nodata: 'No data',
                },
                zh: {
                    systemList: '告警消息推送',
                    nodata: '暂无数据',
                },
            },
        },
    })
], imageBox);
export default imageBox;
